import React, { ReactNode, MouseEventHandler, useState } from 'react';
import Spinner from '../Spinner/Spinner';

interface CoralButtonProps {
    children: ReactNode;
    onClick: MouseEventHandler<HTMLButtonElement>;
    className?: string;
    disabled?: boolean;
    popOnHover?: boolean;
}

const CoralButton: React.FC<CoralButtonProps> = ({ children, onClick, className = '', disabled = false, popOnHover = false}) => {
    const [isLoading, setIsLoading] = useState(false);

    const handleClick: MouseEventHandler<HTMLButtonElement> = async (event) => {
        if (!disabled && !isLoading) {
            setIsLoading(true);
            try {
                await onClick(event);
            } finally {
                setIsLoading(false);
            }
        }
    };

    return (
        <button
            onClick={handleClick}
            className={`
                text-sm font-bold uppercase tracking-wide px-6 py-3 rounded-full transition-all duration-300 ease-in-out
                ${className}
                ${disabled || isLoading ? 'bg-gray-200 text-gray-500 cursor-not-allowed' : 'bg-coral-pink text-white hover:bg-coral-red'}
                ${popOnHover ? 'transform hover:scale-105' : ''}
                flex items-center justify-center
            `}
            disabled={disabled || isLoading}
        >
            {isLoading ? (
                <Spinner />
            ) : (
                <span className="pointer-events-none">{children}</span>
            )}
        </button>
    );
};

export default CoralButton;